<template lang="html">


<div class="wrapper margin-menu">

  <section class="intro column-center -fundacion">
    <h2>La Fundación</h2>
    <h1>Transparencia</h1>
  </section>

  <section class="breadcrumb">
    <nav class="container row-end">
      <router-link to="/">Inicio</router-link>
      <router-link :to="$t('enlaces.lafundacion')">La Fundación</router-link>
      <router-link :to="$t('enlaces.transparencia')">Transparencia</router-link>
    </nav>
  </section>

  <main>

    <div class="container">
      
      <h2 class="title-intro">
        Siempre <strong>transparentes</strong>
      </h2>
  
      <p class="texto-intro">
        Como organización sin ánimo de lucro tenemos el compromiso de transparencia con la sociedad. Es necesario para ello informar de nuestras cuentas y de nuestras actividades de manera clara y entendible a través de los documentos de esta sección. También damos información de los miembros de los órganos de gobierno y de los códigos por los que se rigen nuestras acciones.
      </p>

    </div>

    <div class="grey-box column-center">
      <h2 class="big-title -white">Transparentes</h2>
      <h2 class="title-intro">
        Información <strong>económica</strong>
      </h2>
      <h3 class="title">Balance, cuenta de resultados y memoria</h3>
      <a class="btn with-border" target="_blank" href="/static/pdf/informacion-economica.pdf">Descargar</a>
    </div>


    <h2 class="title-intro">
      Gobierno
    </h2>


    <div class="gobierno-box">
      <div class="container">
        <h2 class="big-title">Gobierno</h2>
      </div>
      <div class="container">
        <img src="/static/img/pieza-puzzle.svg" class="pieza-puzzle">

        <div class="contenedor-cargos row-center">

          <h4>Es patronato nato</h4>

          
          <div class="cargo">
            <h2>Doña Pilar Gómez-Cuétara Fernández</h2>
            <h3>Presidenta Honorífica</h3>

          </div>

        </div>

        <div class="contenedor-cargos row-between">

          <h4>Son patronos vitalicios</h4>

          
          <div class="cargo">
            <h2>Doña Pilar Pascual Gómez-Cuétara</h2>
            <h3>Presidenta Ejecutiva</h3>

          </div>
          <div class="cargo">
            <h2>Don Tomás Pascual Gómez-Cuétara</h2>
            <h3>Vocal</h3>

          </div>
          
          <div class="cargo">
            <h2>Doña Sonia Pascual Gómez-Cuétara</h2>
            <h3>Secretaria</h3>

          </div>
          
          <div class="cargo">
            <h2>Don Borja Pascual Gómez-Cuétara</h2>
            <h3>Vocal</h3>

          </div>
          
        </div>

        <div class="contenedor-cargos row-center no-line">

    
          <div class="cargo">
            <h2>Emilio Martín González</h2>
            <h3>Vicesecretario-tesorero no patrono</h3>

          </div>

        </div>

        <h2 class="title-intro">
          Gestión
        </h2>
        <div class="contenedor-cargos row-center no-line mb0">
        <div class="cargo">
          <h2>Doña Pilar Pascual Gómez-Cuétara</h2>
          <h3>Directora General</h3>
          
        </div>
      </div>


      <div class="contenedor-cargos no-line row-between">

      
        <div class="cargo">
          <h2>Gabriel Torres Pascual</h2>
          <h3>Responsable de Proyectos</h3>
          <p>Fomento del emprendimiento​</p>
        </div>
        <div class="cargo">
          <h2>Carlos Doménech Martínez</h2>
          <h3>Responsable de Proyectos</h3>
          <p>Agua para todos</p>
        </div>
      
        
      </div>


          
      </div>
    </div>


    <div class="grey-box column-center -estatutos">
      <div class="container">

        <h2 class="big-title -white -right">
          <img src="/static/img/libreta-estatutos.svg" alt="Libreta estatutos" class="libreta">
          Estatutos
        </h2>
        
            <p class="texto-intro"><strong>La Fundación Tomás Pascual y Pilar Gómez-Cuétara ha desarrollado un reglamento interno, los Estatutos de la Fundación, que recogen los fines de la Fundación y las actividades necesarias para la consecución de los mismos.</strong> Incluyen asimismo las reglas básicas para la aplicación de los recursos, así como las organización de órganos de gobierno y de gestión que la rigen y administran.</p>
            <a class="btn with-border"  target="_blank" href="/static/pdf/Estatutos_Fundacion_Tomas_Pascual.pdf">Descargar estatutos</a>
      </div>
    </div>



      <div class="cuerpos-descargas container row-between">

        <div class="cuerpo-descarga">
          <h2>Código de buen gobierno</h2>
          <p>Nos comprometemos a seguir las recomendaciones contenidas en el Código de Buen Gobierno de las Sociedades Cotizadas, cuyas buenas prácticas las integramos en nuestro modelo de gobierno.</p>
          <a  target="_blank" href="/static/pdf/codigo-de-buen-gobierno.pdf" class="btn with-border" >Descargar</a>
        </div>

        <div class="cuerpo-descarga">
          <h2>Informe de gestión y negocio responsable</h2>
          <p>El informe de gestión y negocio responsable incluye todos los datos relevantes de la gestión realizada por la Corporación Pascual a lo largo del año.</p>
          <a target="_blank" href="/static/pdf/informedenegocioresponsable.pdf" class="btn with-border">Descargar</a>
        </div>

      </div>


  </main>

</div>

</template>

<script lang="js">


export default {
  name: 'transparencia',
}
  
</script>


<style lang="scss">

</style>



<style lang="scss" scoped>
  
  @media screen and (max-width: 1200px){
    .grey-box .big-title{
        font-size: 130px;
    }
  }

  @media screen and (max-width: 900px){
    .grey-box .big-title{
        font-size:100px;
    }

    .texto-intro{
        padding: 0 20px;
    }
  }

  @media screen and (max-width: 750px){

    .grey-box:not(.-estatutos){
      padding-top: 90px;
      padding-bottom: 30px;
      padding-left: 20px;
      padding-right: 20px;
    }
    .grey-box .big-title{
        font-size:70px;
    }
  }

  @media screen and (max-width: 560px){
    .grey-box .big-title{
        font-size:55px;
    }

    .texto-intro{
      padding: 0;
      text-align: center;
      &:last-of-type{
        padding: 0 20px;
      }
    }
  }

  @media screen and (max-width: 400px){
    .grey-box .big-title{
        font-size:38px;
    }
  }

</style>


// WEBPACK FOOTER //
// src/components/views/transparencia.vue